export * from './doc-printable'
